import { cn } from "@/lib/utils";
import { Zap, BarChart3, Search } from "lucide-react";

export type ReportVersion = 'express' | 'snapshot' | 'deep_dive';

interface ReportVersionSelectorProps {
  value: ReportVersion;
  onChange: (version: ReportVersion) => void;
  className?: string;
}

const versions: { key: ReportVersion; label: string; credits: number; time: string; icon: React.ElementType; description: string }[] = [
  { key: 'express', label: 'Express', credits: 1, time: '~60s', icon: Zap, description: 'Quick results' },
  { key: 'snapshot', label: 'Snapshot', credits: 3, time: '~2-3 min', icon: BarChart3, description: 'Full analysis' },
  { key: 'deep_dive', label: 'Deep Dive', credits: 6, time: '~5-7 min', icon: Search, description: 'Complete intel' },
];

export function ReportVersionSelector({ value, onChange, className }: ReportVersionSelectorProps) {
  return (
    <div className={cn("grid grid-cols-3 gap-3", className)}>
      {versions.map(({ key, label, credits, time, icon: Icon, description }) => {
        const isSelected = value === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className={cn(
              "relative flex flex-col items-center gap-1.5 rounded-lg border-2 p-3 text-center transition-all",
              isSelected
                ? "border-primary bg-primary/5 shadow-sm"
                : "border-border bg-card hover:border-primary/40"
            )}
          >
            <Icon className={cn("h-5 w-5", isSelected ? "text-primary" : "text-muted-foreground")} />
            <span className={cn("text-sm font-semibold", isSelected ? "text-primary" : "text-foreground")}>{label}</span>
            <span className="text-xs text-muted-foreground">{description}</span>
            <div className="flex items-center gap-2 mt-1">
              <span className={cn(
                "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
                isSelected ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"
              )}>
                {credits} {credits === 1 ? 'credit' : 'credits'}
              </span>
              <span className="text-xs text-muted-foreground">{time}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
